module.exports = {
	"id": "HT",
	"name": "Haiti",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.081872,
			"12": 0.01904,
			"13": 0.036176,
			"14": 0.003808,
			"15": null,
			"16": 0.003808,
			"17": 0.005712,
			"18": 0.003808,
			"19": null,
			"20": 0.003808,
			"21": null,
			"22": 0.007616,
			"23": null,
			"24": null,
			"25": 0.003808,
			"26": 0.001904,
			"27": 0.005712,
			"28": 0.003808,
			"29": 0.007616,
			"30": 0.020944,
			"31": 0.011424,
			"32": 0.003808,
			"33": 0.024752,
			"34": 0.013328,
			"35": 0.00952,
			"36": 0.017136,
			"37": 0.00952,
			"38": 0.011424,
			"39": 0.00952,
			"40": 0.02856,
			"41": 0.020944,
			"42": 0.00952,
			"43": 0.060928,
			"44": 0.011424,
			"45": 0.087584,
			"46": 0.015232,
			"47": 0.034272,
			"48": 0.015232,
			"49": 0.35224,
			"50": 0.045696,
			"51": 0.32368,
			"52": 0.144704,
			"53": 6.058528,
			"54": 1.578416,
			"55": 0.020944,
			"56": 0.001904,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.108528,
			"4": 0.011424,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.003808,
			"11": 0.007616,
			"12": 0.007616,
			"13": 0.001904,
			"14": 0.001904,
			"15": 0.003808,
			"16": 0.003808,
			"17": 0.001904,
			"18": 0.003808,
			"19": 0.007616,
			"20": 0.003808,
			"21": 0.01904,
			"22": 0.00952,
			"23": 0.003808,
			"24": 0.003808,
			"25": 0.003808,
			"26": 0.001904,
			"27": 0.003808,
			"28": 0.01904,
			"29": 0.003808,
			"30": 0.024752,
			"31": 0.011424,
			"32": 0.011424,
			"33": 0.007616,
			"34": 0.007616,
			"35": 0.003808,
			"36": 0.007616,
			"37": 0.017136,
			"38": 0.036176,
			"39": 0.003808,
			"40": 0.005712,
			"41": 0.01904,
			"42": 0.007616,
			"43": 0.0952,
			"44": 0.017136,
			"45": 0.07616,
			"46": 0.01904,
			"47": 0.249424,
			"48": 0.272272,
			"49": 1.890672,
			"50": 0.03808,
			"51": 0.001904,
			"52": 0.001904,
			"3.5": null,
			"3.6": 0.015232
		},
		"opera": {
			"9": null,
			"11": 0.001904,
			"12": 0.011424,
			"15": null,
			"16": null,
			"17": 0.003808,
			"18": null,
			"19": 0.007616,
			"20": 0.005712,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.003808,
			"25": null,
			"26": 0.001904,
			"27": 0.03808,
			"28": 0.017136,
			"29": 0.178976,
			"30": 0.00952,
			"31": null,
			"32": 0.001904,
			"33": 0.011424,
			"34": 0.003808,
			"35": 0.003808,
			"36": 0.024752,
			"37": 0.167552,
			"38": 0.005712,
			"39": 0.026656,
			"40": 0.403648,
			"41": 0.049504,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.005712,
			"11.1": null,
			"11.5": 0.011424,
			"11.6": 0.02856,
			"12.1": 0.072352
		},
		"safari": {
			"0": null,
			"4": 0.001904,
			"5": 0.017136,
			"6": 0.001904,
			"7": 0.005712,
			"8": 0.097104,
			"9": 0.039984,
			"10": 0.312256,
			"3.1": null,
			"3.2": null,
			"5.1": 0.022848,
			"6.1": 0.024752,
			"7.1": 0.001904,
			"9.1": 0.264656
		},
		"ios_saf": {
			"8": 0,
			"10": 2.20795337635,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0595017886137,
			"8.1-8.4": 0.109927033201,
			"9.0-9.2": 0.0524422543714,
			"9.3": 0.80008054746
		},
		"android": {
			"3": 0,
			"4": 0.221095994832,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.027636999354,
			"4.1": 0.797524838501,
			"4.2-4.3": 1.99381209625,
			"4.4": 4.57194932171,
			"4.4.3-4.4.4": 4.61143074935
		},
		"ie": {
			"6": 0.030464,
			"7": 0.003808,
			"8": 0.213248,
			"9": 0.10472,
			"10": 0.163744,
			"11": 1.27568,
			"5.5": null
		},
		"op_mob": {
			"0": 2.09791332028,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0582753700079
		},
		"edge": {
			"12": 0.146608,
			"13": 0.253232,
			"14": 0.224672
		},
		"ie_mob": {
			"10": 0.169196901408,
			"11": 0.688873098592
		},
		"bb": {
			"7": 0.06476,
			"10": null
		},
		"samsung": {
			"0": 1.724235
		},
		"and_uc": {
			"0": 4.476535
		},
		"op_mini": {
			"0": 28.2648213097
		},
		"and_chr": {
			"0": 29.332578
		},
		"and_ff": {
			"0": 0.024285
		}
	},
	"total": 98.864412
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/HT.json
 ** module id = 545
 ** module chunks = 0
 **/